import { CustomTriageRule, TriageRules } from './triage-rule';

TriageController.$inject = ['$scope', '$translate', '$mdDialog', 'company', 'sites', 'siteGroups', 'TriageFactory', 'AlertingFactory', 'ConfirmationFactory', 'TopToolbarFactory', '$stateParams'];
export function TriageController($scope, $translate, $mdDialog, company, sites, siteGroups, TriageFactory, AlertingFactory, ConfirmationFactory, TopToolbarFactory, $stateParams) {

  $scope.editRule = editRule;
  $scope.deleteRule = deleteRule;
  $scope.addRule = addRule;
  $scope.save = save;
  $scope.enableSave = enableSave;
  $scope.getHtmlRuleId = getHtmlRuleId;
  $scope.dropdownItems = [];
  $scope.accountsMap = new Map();

  $scope.MAX_TRIAGE_RULES = 50;

  init();

  function getRuleIndexById(ruleId) {
    for (let i = 0; i < $scope.rules.rules.length; i++) {
      if ($scope.rules.rules[i].id == ruleId) {
        return i;
      }
    }
    return null;
  }

  function editRule(index, event) {
    enableSave();
    $mdDialog.show({
      'controller': 'TriageRuleEditionController',
      'template': require('./triage-rule-edition.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        'rule': $scope.rules.getRuleDeepCopy(index),
      }
    })
      .then(function (modifiedRule) {
        $scope.rules.updateRule(index, modifiedRule);
      },
        () => {
          // Case of cancelling the edition dialog after creating a new rule
          if (!event) {
            $scope.rules.deleteRule(index);
            _checkRulesNumberLimitation();
          }
        });
  }

  function deleteRule(index) {
    ConfirmationFactory.materialConfirmDialog('priority-rules/confirm-deletion')
      .then(function () {
        enableSave();
        $scope.rules.deleteRule(index);
        _checkRulesNumberLimitation();
      });

  }

  function addRule(event) {
    enableSave();
    TriageFactory.getTriageConfigurationRuleUniqueId(company.id)
      .then(
        response => {
          const newRule = {
            'id': response.data,
            'title': $translate.instant('triage_config/edition/default-rule-title')
          }
          $scope.rules.addRule(new CustomTriageRule(newRule));
          editRule($scope.rules.lastRuleIndex(), event);
          _checkRulesNumberLimitation();
        },
        AlertingFactory.httpErrorHandler());

  }

  function save() {
    const configuration = {
      'previous_log_id': $scope.currentLogId,
      'rules': $scope.rules.rules
    }
    TriageFactory.updateTriageConfiguration(company.id, configuration)
      .then((response) => {
        $scope.currentLogId = response.data.new_log_id;
        AlertingFactory.success('triage_config/update-success');
        _checkRulesNumberLimitation();
        _disableSave();
      },
        AlertingFactory.httpErrorHandler());
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function _disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
  }

  function initAfterConfigLoaded(config) {
    $scope.currentLogId = config.id;
    $scope.rules = TriageRules.fromBackEnd(config.rules, $scope.accountsMap);
    if ($stateParams.triageRuleId) {
      editRule(getRuleIndexById($stateParams.triageRuleId), null);
    }
    if ($stateParams.blinkRuleId) {
      setTimeout(() => scrollToAndBlinkRule($stateParams.blinkRuleId), 0);
    }
  }

  function scrollToAndBlinkRule(ruleId) {
    const elementId = getHtmlRuleId(ruleId);
    let element = document.getElementById(elementId);
    element.scrollIntoView({
      behavior: 'smooth'
    });
    element.classList.add("alc-blink");

  }

  function getHtmlRuleId(ruleId) {
    return TriageFactory.getHtmlRuleId(ruleId);
  }

  function _checkRulesNumberLimitation() {
    TopToolbarFactory.updateSecondaryButtonDisable($scope.rules.rules.length >= $scope.MAX_TRIAGE_RULES, $scope);
  }

  function init() {

    TopToolbarFactory.setButton('save', save, $scope);
    TopToolbarFactory.setSecondaryButton('triage_config/create', addRule, $scope);

    _disableSave();

    $scope.isLoading = true;

    TriageFactory.getTriageConfiguration(company.id)
      .then(response => {
        $scope.dropdownItems = TriageFactory.buildDropdownItems(company, sites, siteGroups, company.tags_groups);
        ($scope.dropdownItems.sites || []).forEach(account => {
          $scope.accountsMap.set(account.key, account);
        });
        initAfterConfigLoaded(response.data);
        _checkRulesNumberLimitation();
      },
        AlertingFactory.httpErrorHandler())
      .finally(() => $scope.isLoading = false);

    $scope.rulesSortOptions = {
      axis: 'y',
      cursor: 'move',
      handle: '.drag-handle',
      change: () => enableSave()
    }
  }

}
